import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  HostListener,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurrentEventService } from '../../services/current-event.service';
import { GenericEvent } from '../../models/event.model';
import { environment } from '../../../environments/environment';
import { Subject, takeUntil } from 'rxjs';

const PLACEHOLDER_ISI = `
<p><em><strong>Lorem ipsum dolor sit amet</strong></em>, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
<p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. <strong>Contraindications:</strong> Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.</p>
<p><strong>Warnings and Precautions:</strong> Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae.</p>
<p>Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis doloribus asperiores repellat. Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur.</p>
`;

@Component({
  selector: 'app-layout',
  imports: [CommonModule],
  templateUrl: './layout.html',
  styleUrl: './layout.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutComponent implements OnInit, OnDestroy {
  event: GenericEvent | null = null;
  showStickyIsiBar = false;
  isiExpanded = true;  // Default open, mirroring omni-mobile behavior

  @ViewChild('isiSection') isiSectionRef!: ElementRef<HTMLElement>;

  private destroy$ = new Subject<void>();
  private stickyBarHeight = 48;
  private hysteresis = 12;

  constructor(
    private currentEventService: CurrentEventService,
    private cdr: ChangeDetectorRef
  ) {}

  get showIsi(): boolean {
    return !!(this.event && (this.event.topicIsi || environment.features.showIsiPlaceholder));
  }

  get hasRealIsi(): boolean {
    return !!this.event?.topicIsi;
  }

  get isiContent(): string {
    return this.event?.topicIsi || PLACEHOLDER_ISI;
  }

  ngOnInit() {
    this.currentEventService.event$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(event => {
      this.event = event;
      if (this.showIsi) {
        this.showStickyIsiBar = true;
      }
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  @HostListener('window:scroll')
  onScroll() {
    if (!this.event || !this.showIsi || !this.isiSectionRef?.nativeElement) {
      return;
    }

    const rect = this.isiSectionRef.nativeElement.getBoundingClientRect();
    const screenHeight = window.innerHeight;
    const hideLine = screenHeight - this.stickyBarHeight - this.hysteresis;

    // Hide sticky bar when the ISI section is visible on screen
    this.showStickyIsiBar = rect.top > hideLine;
  }

  scrollToIsi() {
    if (this.isiSectionRef?.nativeElement) {
      this.isiSectionRef.nativeElement.scrollIntoView({ behavior: 'smooth' });
    }
  }

  toggleIsi() {
    this.isiExpanded = !this.isiExpanded;
  }
}
